import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { useGetAppStoreDataByIdQuery } from '../../redux/apis/linkManagement/app/data/lmAppsDataApiSlice'
import { toast } from 'react-toastify'
import Loader from '../pages/loader'
import { useParams } from 'react-router-dom'
import { Card, CardBody, CardHeader } from '../../components/other/card/card'

const appDataInfo = React.memo(() => {
  const context = useContext(AppSettings)
  const { id } = useParams()
  const { data, isLoading, error } = useGetAppStoreDataByIdQuery({
    expand: ['last_updated_by', 'app', 'app_store', 'status', 'customers','inserted_by'].join(
      ','
    ),
    id: id
  })

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context]) // Add context as a dependency

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading} />
      <Card>
        <CardHeader>{data?.data?.app?.app_name}</CardHeader>
        <CardBody>
          <table className='table table-striped'>
            <tbody>
              <tr>
                <th scope='row'>App Store Name</th>
                <td>{data?.data?.app_store?.app_store_name}</td>
              </tr>
              <tr>
                <th scope='row'>Application Name</th>
                <td>{data?.data?.app?.app_name}</td>
              </tr>
              <tr>
                <th scope='row'>Application URL</th>
                <td>
                  <a href={data?.data?.url} target='_blank'>Click Here</a>
                </td>
              </tr>
              <tr>
                <th scope='row'>Crawl Date</th>
                <td>{data?.data?.crawl_date}</td>
              </tr>
              <tr>
                <th scope='row'>Review Date</th>
                <td>{data?.data?.review_date}</td>
              </tr>
              <tr>
                <th scope='row'>Report Date</th>
                <td>{data?.data?.report_date}</td>
              </tr>
              <tr>
                <th scope='row'>Remove Date</th>
                <td>{data?.data?.remove_date}</td>
              </tr>
              <tr>
                <th scope='row'>Report Case ID</th>
                <td>{data?.data?.report_case_id}</td>
              </tr>
              <tr>
                <th scope='row'>Installation Count</th>
                <td>{data?.data?.installation_count}</td>
              </tr>
              <tr>
                <th scope='row'>Status</th>
                <td>{data?.data?.status?.status}</td>
              </tr>
              <tr>
                <th scope='row'>Created By</th>
                <td>{data?.data?.inserted_by?.first_name} {data?.data?.inserted_by?.last_name}</td>
              </tr>
              <tr>
                <th scope='row'>Created At</th>
                <td>{data?.data?.created_at}</td>
              </tr>
              <tr>
                <th scope='row'>Last Updated By</th>
                <td>{data?.data?.last_updated_by?.first_name} {data?.data?.last_updated_by?.last_name}</td>
              </tr>
              <tr>
                <th scope='row'>Updated At</th>
                <td>{data?.data?.updated_at}</td>
              </tr>
            </tbody>
          </table>
        </CardBody>
      </Card>
    </div>
  )
})

export default appDataInfo
